import React from "react";
import { IconPhoto } from '@tabler/icons-react';
import StoryboardToolbarIcon from "./StoryboardToolbarIcon";
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const StoryboardLinkButton = ({ projectKey, preview, iconColour, framed = false, inGroup = false }) => {
    if (preview) {
        return (
            <EditorToolbarIcon
                label="View storyboard"
                component="a"
                href={`/${projectKey}`}
                target="_blank"
                iconColour={iconColour}
                inGroup={inGroup}
            >
                <IconPhoto size={CHROME_TOOLBAR_ICON_GLYPH} />
            </EditorToolbarIcon>
        );
    }

    if (framed) {
        return (
            <StoryboardToolbarIcon
                label="Open storyboard editor"
                component="a"
                href={`/storyboard-editor/${projectKey}`}
                target="_blank"
                rel="noreferrer"
            >
                <IconPhoto size={CHROME_TOOLBAR_ICON_GLYPH} />
            </StoryboardToolbarIcon>
        );
    }

    return (
        <EditorToolbarIcon
            label="Open storyboard editor"
            component="a"
            href={`/storyboard-editor/${projectKey}`}
            target="_blank"
            iconColour={iconColour}
            inGroup={inGroup}
        >
            <IconPhoto size={CHROME_TOOLBAR_ICON_GLYPH} />
        </EditorToolbarIcon>
    );
};

export default StoryboardLinkButton;
